import MainContainer from "../layout/MainContainer.tsx";
import {Redirect, Route} from "wouter";
import PostsHome from "./posts/PostsHome.tsx";
import PostsCreateOrUpdate from "./posts/PostsCreate.tsx";
import TypeOfPostChooser from "./posts/TypeOfPostChooser.tsx";
import SettingsIndex from "./settings/SettingsIndex.tsx";
import ConnectAccount from "./accounts/ConnectAccount.tsx";
import MyAccounts from "./accounts/MyAccounts.tsx";
import Dashboard from "./dashboard/Dashboard.tsx";
import Discover from "./discover/Discover.tsx";
import useSWR from "swr";
import {swrFetcher} from "../utils/api.ts";
import {useAccessToken} from "../components/hooks/useAccessToken.ts";
import React, {useEffect} from "react";
import WorkspaceEditor from "./workspace/WorkspaceEditor.tsx";
import MediaAssets from "./assets/MediaAssets.tsx";
import LazyEditImageRedirect from "./polotno/LazyEditImageRedirect.tsx";
import AccountDetails from "./accounts/AccountDetails.tsx";
import ViewPublishedPost from "./posts/ViewPublishedPost.tsx";
import Spinner from "@/components/spinner.tsx";
import Support from "@/pages/extras/Support.tsx";
import PostVariations from "@/pages/posts/PostVariations.tsx";


function Index() {
    const {access_token} = useAccessToken()
    const {data, isLoading} = useSWR(
        access_token ?
        '/auth/me' : null, swrFetcher)

    if(isLoading){
        return <div className={"text-center mt-4 pt-4"}><Spinner /></div>
    }else if(data?.error){
        return <Redirect to={"/auth?error=Login token expired"} />
    }
    if(!access_token){
        return <Redirect to={"/auth?error=Not logged in"} />
    }
    return (
        <>
            <MainContainer>
                 <Route path={"/"} component={Dashboard} />
                 {/*<Route path={"/upgrade"} component={BillingPage} />*/}
                 <Route path={"/settings"} component={SettingsIndex} />
                 <Route path={"/assets"} component={MediaAssets}/>
                 <Route path={"/image_editor/:data"} component={LazyEditImageRedirect}/>
                 <Route path={"/accounts"} component={MyAccounts} />
                 <Route path={"/accounts_connect"} component={ConnectAccount} />
                 <Route path={"/accounts/details/:id"} component={AccountDetails} />
                 <Route path={"/accounts/:platform"} component={MyAccounts} />
                 <Route path={"/posts"} component={PostsHome} />
                 <Route path={"/posts/upcoming"} component={PostsHome} />
                 <Route path={"/posts/published"} component={PostsHome} />
                 <Route path={"/posts/published/:id"} component={ViewPublishedPost} />
                 <Route path={"/settings/workspaces/:id"} component={WorkspaceEditor} />
                 <Route path={"/posts/create/:type"} component={PostsCreateOrUpdate}/>
                 <Route path={"/posts/edit/:id"} component={PostsCreateOrUpdate}/>
                 <Route path={"/posts/variations/:id"} component={PostVariations}/>

                 <Route path={"/discover"} component={Discover} />
                 <Route path={"/support"} component={Support} />
                 <Route path={"/posts/create"} component={TypeOfPostChooser}/>
                 <Route path={"/logout"} component={Logout}/>
            </MainContainer>
        </>
    );
}


function Logout() {
    const {setAccessToken} = useAccessToken()
    useEffect(()=>{
        setAccessToken('');
    },[setAccessToken])
    return <Redirect to={"/auth"} />
}


export default Index;
